import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../../App";
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from "../../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { handleUserLevelAccessPermissions, validateRolesIIPHQ } from "../../../../../Custom/Custom";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { generateExcelGroupIndexAnnualReport } from "../../ExportIIPExcel";
import iipTitleData from '../../../../../iip.json';
import messages from '../../.././../../assets/Messages.json';


const GroupIndexAnnualReport = () => {
  const [years, setYears] = useState([]);
  const [yearName, setYearName] = useState("");
  const [groupIndexAnnualReportData, setGroupIndexAnnualReportData] = useState([]);
  // const [IIPAnnualAgricultureReportbaseYear, setIIPAnnualAgricultureReportbaseYear] = useState(null);
  const [buttonAccess, setButtonAccess] = useState({
    userLevel: "",
    roles: "",
    isVisible: false,
  });
  const [yearNameNextTitle, setYearNameNextTitle] = useState([]);
  const token = useContext(MyContextProvider).token;
  const decode_token = getUserClaimsForUi();
  const navigate = useNavigate();
  const config = getAuthHeaders();




  const storedLanguage = localStorage.getItem('language');

  //get next Years 
  const getNextYear = (year) => {
    const nextYear = parseInt(year) + 1;
    return `${year}-${nextYear}`;
  };



  //get Years 
  const getAllYears = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth(); 
    const currentFinancialYearStart = currentMonth < 3 ? currentYear - 1 : currentYear;
    
    const yearsArray = [];
    for (let year = currentFinancialYearStart; year >= 2021; year--) {
      yearsArray.push(year);
    }
    return yearsArray;
  };


  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);
    const getYearList = () => {
      setYears(getAllYears());
    };

    const userRole = async () => {
      showLoading(true);
      try {
        const role = await validateRolesIIPHQ(decode_token);
        if (role) {
          getYearList();
        } else {
          alert(
            "You are not an authorized for IIP Report."
          );
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false);
      } finally {
        showLoading(false);
      }
    };

    userRole();
  }, []);



  const handleDropdownChange = (e) => {

    switch (e.target.name) {
      case 'year_name':
        let postData = {
          surveyYear: e.target.value,
        }
        setYearName(e.target.value)
        onChangGroupIndexAnnualReportDataDetails(postData)
        break;
      default:
        console.log("switch case are not match");
        break;

    }
  }

  const onChangGroupIndexAnnualReportDataDetails = async (postData) => {
    showLoading(true);
    try {
      const response = await axios.post(`${API_URL}api/iipReports/HQreports/GroupIndexAnnualReports`, postData, config);
     
      const allData = response.data.data.GroupCodes;

      if (allData && allData.length > 0) {
        setGroupIndexAnnualReportData(allData);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      showLoading(false);
    }
  };

  // Function to generate Excel file using mapped data
  
  
  const handleGenerateExcel = async () => {
   
    if (!yearName) {
      toast.error("Please select a Survey Year", messages.COLOR_RED);
      return;
    }
  
    const excelFileName = `AnnualGroupIndexReport_${yearName}`;

    const excelObjectData = {
      fileName: excelFileName,
      reportType: excelFileName,
      fileType: 'xlsx',
      sheetName: "IIPAnnualGroupIndexReport",
      firstRowMergeCells: "A1:O1",
      firstRowExportData: 'ECONOMICS & STATISTICS DIVISION, UTTAR PRADESH',
      firstRowCellNumber: 15,
      secondRowMergeCells: "A2:O2",
      secondRowText: 'INDUSTRIAL PRODUCTION INDEX  U.P',
      thirdRowMergeCells: "A3:O3",
      thirdRowText: `Annual Production Details - (${yearName} - ${parseInt(yearName) + 1})`,
      fourthRowMergeCells: "A4:O4",
      fourthRowText: "Major Industry wise Group Index Report (BASE YEAR 2011 - 12)",
      // baseYear: IIPAnnualAgricultureReportbaseYear,
      headerEnglishColumns: [
        'Industry Code', 'Description', 'Weight', 'April', 'May', 'June', 'July', 'August', 'Sept', 'Oct', 'Nov', 'Dec'
      ],
      excelRowData: groupIndexAnnualReportData.map(item => [
        item.nic2d,
        item.item_name,
        item.weight,
        item.index_apr,
        item.index_may,
        item.index_jun,
        item.index_jul,
        item.index_aug,
        item.index_sep,
        item.index_oct,
        item.index_nov,
        item.index_dec,
        item.index_jan,
        item.index_feb,
        item.index_mar
      ]),
    };

   

    generateExcelGroupIndexAnnualReport(excelObjectData); // Call function to generate Excel
  };
  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
              <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? iipTitleData.hi.GROUP_INDEX_ANNUAL_REPORT : iipTitleData.en.GROUP_INDEX_ANNUAL_REPORT }} />
              </h4>
              <div className="row align-items-center">

                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label className="fw-bold h6">Survey Year</label>
                  <select
                    name="year_name"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={yearName}
                  >
                    <option value="" disabled>
                      Select Year
                    </option>
                    {years &&
                      years.map((ele, index) => (
                        <option key={index} value={ele}>
                          {getNextYear(ele)}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-xl-2 col-lg-12 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGenerateExcel} className="btn btn_orange">Generate Report</button>
                </div>


              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}

export default GroupIndexAnnualReport